
import { defineComponent, PropType } from 'vue'

import { CourierReport } from '@/new-services/types/couriers'

export default defineComponent({
    props: {
        column: {
            type: Object as PropType<{ name: string; key: string }>,
            required: true,
        },
        row: {
            type: Object as PropType<CourierReport>,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        const emitToggle = (row: CourierReport) => {
            emit('toggle', row.id)
        }

        return {
            emitToggle,
        }
    },
})
